

exports.__esModule = true;
exports["default"] = void 0;
var _squid = require("squid");
var _angular = require("angular");
var _template = _interopRequireDefault(require("./template"));
require("xo-form-components/src/travel-rule/directive");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoTravelRuleLightbox', {
  tag: 'xo-travel-rule-lightbox',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    doneFn: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      // Open interstitial after element is rendered
      (0, _angular.$timeout)(function () {
        _this.modalOpen = true;
      });
    }
  }
});
_squid.$Component;
_angular.$timeout;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-guest-components/src/guest/travelRuleLightbox/directive.js
// module id = ../node_modules/xo-guest-components/src/guest/travelRuleLightbox/directive.js
// module chunks = 0